import React, { useEffect, useState } from 'react'
import { fynitoApi } from '../Services/axios';
import { useDispatch } from 'react-redux';
import { loadingStart, loadingStop } from '../../redux/features/loading/loadingSlice';
import MobileBottomBar from '../Layout/MobileBottomBar';

const Wallet = () => {
    const [refundList, setRefundList] = useState([]);
    const [currentBalance, setCurrentBalance] = useState(null);
    const dispatch = useDispatch();

    // Fetch Wallet Api
    const fetchWalletRefunds = async () => {
        dispatch(loadingStart())
        try {
            const res = await fynitoApi.get('/wallet-refund-list');
            if (res.data.status_code === 200) {
                setRefundList(res.data.data.data)
                setCurrentBalance(res?.data?.current_wallet_balance)
            } else {

            }
        } catch (error) {
        }
        finally {
            dispatch(loadingStop());
        }
    }

    useEffect(() => {
        fetchWalletRefunds();
    }, []);
    return (
        <>
            <section className="wallet-sec tp-space pt-100">
                <div className="container">
                    <div className="wallet-card">
                        <h5>Total Wallet Balance</h5>
                        <h3>₹ {currentBalance}</h3>
                    </div>
                    <ul className="wallet-pay-list">
                        {
                            refundList.length > 0 ? (
                                refundList.map((amount, index) => {
                                    return (
                                        <li key={amount.id}>
                                            <div className="wallet-pay-list-lft">
                                                <span><i className="fa-solid fa-arrow-right"></i></span>
                                                <div>
                                                    <h5>Refund From Fynito</h5>
                                                    <p>{amount.new_date_time}</p>
                                                </div>
                                            </div>
                                            <div className="wallet-pay-list-rgt">
                                                <h6>₹ {amount.amount}</h6>
                                            </div>
                                        </li>
                                    )
                                })
                            ) : (
                                <p className='text-center text-danger h4'> <i className='fa fa-xmark mb-2'></i><br /> No Data Found</p>
                            )
                        }

                    </ul>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Wallet